/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { listAttachments } from '../../../../assets/ts/data/files/files'
import {
  COLUMN_NAMES as KnowledgeBaseCols,
  KnowledgeBase as KnowledgeBaseInterface,
  LIST_NAME as KnowledgeBaselist,
  saveOrUpdateKnowledgeBase,
} from '../../../../assets/ts/data/knowledge-base'
import { convertRTE } from '../../../../assets/ts/formatting/formatting'
import { generateCategoryOptions } from '../../../../assets/ts/general/general'
import {
  addToPIIAuditTrail,
  getPIIScanInfo,
  handlePIIValidationFailure,
  loadPII,
} from '../../../../assets/ts/pii/pii'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import FileUpload from '../../../../components/file-upload/file-upload'
import PIIPopup from '../../../../components/page-overlay/pii-popup'
import { MetadataContextInterface } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputText from '../../../../utils/controls/input-text'
import RichTextEditor from '../../../../utils/controls/rich-text-edit'
import { IsArchived, optionsTypes } from '../../../../utils/controls/select-options-data'

interface addOrEditProps {
  addOrEdit?: string
  assignComponents?: MetadataContextInterface['components']
  assignedComponentOptions: any
  cancel?: () => void
  categories?: MetadataContextInterface['categories']
  clickedIndex?: number
  editKnowledgeBase?: any
  filtersvalue?: any
  initialMajcomOptions?: any
  initialSectionOptions?: any
  initialSquadronOptions?: any
  knowledgeBases?: KnowledgeBaseInterface[]
  majcoms?: MetadataContextInterface['majcoms']
  refresh?: boolean
  roleContext?: any
  sectionOption?: optionsTypes[]
  sections?: MetadataContextInterface['sections']
  setKnowledgeBases?: Dispatch<SetStateAction<KnowledgeBaseInterface[]>>
  setRefresh?: Dispatch<SetStateAction<boolean>>
  showAddPopup?: any
  showEdit?: any
  visibleSquadrons?: any
}

const AddEditView = ({
  assignedComponentOptions,
  cancel,
  categories,
  clickedIndex,
  editKnowledgeBase,
  filtersvalue,
  initialMajcomOptions,
  initialSectionOptions,
  knowledgeBases,
  refresh,
  roleContext,
  sections,
  setKnowledgeBases,
  setRefresh,
  showAddPopup,
  showEdit,
  visibleSquadrons,
}: addOrEditProps) => {
  const [oldKnowledgeBases, setOldKnowledgeBases] = useState(knowledgeBases || [])
  const existingFiles = editKnowledgeBase?.Attachments[0]?.blobs
    ? editKnowledgeBase?.Attachments[0]?.blobs
    : []
  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [files, setFiles] = useState(
    editKnowledgeBase?.Attachments[0]?.blobs ? editKnowledgeBase?.Attachments[0]?.blobs : []
  )

  const [fileError, setFileError] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [showPageOverlay, setPageOverlay] = useState(false)

  const [categoryOptions, setCategoryOptions] = useState<Array<optionsTypes>>([])
  const [majcomOptions, setMajcomOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [sectionOptions, setSectionOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [squadronOptions, setSquadronOptions] = useState<Array<optionsTypes>>(
    [ALL_SELECT_OPTION_STRING]
  )

  useEffect(() => {
    const majOptions: any[] = initialMajcomOptions
    .filter(
      (item) => assignedComponentOptions.length > 1 || (
        assignedComponentOptions.length === 1 &&
        assignedComponentOptions[0].value === item.assignedComponentCode
      )
    )
    .map((majcom) => ({
      assignedComponentCode: majcom.assignedComponentCode,
      label: majcom.label,
      squadron: majcom.squadron,
      value: majcom.value,
    }))

  const sectOptions: optionsTypes[] = sections.filter((section) => {
    let containsSquadron = false

    Object.keys(visibleSquadrons).forEach((key) => {
      if (visibleSquadrons[key].length > 0) {
        const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

        if (key === 'SectionChief' || key === 'SectionOwner') {
          if (visibleSquadrons[key]
            .some((e) => e.section === formattedSection &&
              majOptions.some((maj) => maj.squadron.includes(e.squadron)))) {
            containsSquadron = true
          }
        }
      }
    })

    return containsSquadron ||
      roleContext?.isCPOwner ||
      roleContext?.isLeadership ||
      roleContext?.isMPFOwner ||
      roleContext?.isMAJCOMOwner ||
      roleContext?.isAssignedComponentOwner
  }).map((section) => {
    const filteredSectOpt = initialSectionOptions.filter((sect) =>
      sect.value === section?.SectionCode
    )[0]

    return {
      label: section?.Section,
      majcom: filteredSectOpt.majcom,
      squadron: filteredSectOpt.squadron,
      value: section?.SectionCode,
    }
  })

  const squadOptions = []
  majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
    majcom.squadron?.map((item) => {
      squadOptions.push({
        label: item,
        value: item
      })
    })
  })

  if (majOptions.length > 1 && majOptions[0].value !== -1) {
    majOptions.unshift(ALL_SELECT_OPTION)
  }

  if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
    squadOptions.unshift(ALL_SELECT_OPTION_STRING)
  }

  setMajcomOptions(majOptions)
  setSectionOptions(sectOptions)
  setSquadronOptions(squadOptions)

  const categoryOptions = []

    sectOptions.forEach((section) => {
      categoryOptions.push(generateCategoryOptions(
        section.label,
        categories ?? [],
        sections ?? []
      ))
    })

    setCategoryOptions([...new Set(...categoryOptions)])

  handleChange('AssignedComponent', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].label ?? '' : ALL_SELECT_LABEL)
  handleChange('AssignedComponentCode', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].value ?? '' : ALL_SELECT_VALUE)
  handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
  handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
  handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
  handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : ALL_SELECT_VALUE)
  showAddPopup && handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
  !showAddPopup && handleChange('Squadron', editKnowledgeBase?.ServicingOrganization === 'All' ? ALL_SELECT_VALUE_STRING : editKnowledgeBase?.ServicingOrganization)

  }, [
    assignedComponentOptions,
    initialMajcomOptions,
    initialSectionOptions,
    editKnowledgeBase
  ])

  const [displayValidation, setDisplayValidation] = useState({
    showPII: false,
  })
  const [inputValues, setInputValues] = useState({
    Archived: editKnowledgeBase?.IsArchived ? editKnowledgeBase?.IsArchived : false,
    AssignedComponent: editKnowledgeBase?.AssignedComponent
      ? editKnowledgeBase.AssignedComponent
      : ALL_SELECT_LABEL,
    AssignedComponentCode: editKnowledgeBase?.AssignedComponentCode
      ? editKnowledgeBase.AssignedComponentCode
      : ALL_SELECT_VALUE,
    CategoryCodeOptions: [],
    CategoryCodes: editKnowledgeBase?.CategoryCodes?.length > 0 ?
      editKnowledgeBase.CategoryCodes : [],
    Description: editKnowledgeBase?.Description ? editKnowledgeBase.Description : '',
    SectionCodeOptions: [],
    SectionCodes: editKnowledgeBase?.SectionCodes?.length > 0 ?
      editKnowledgeBase.SectionCodes : [],
    ServicingMAJCOM: editKnowledgeBase?.MAJCOM ? editKnowledgeBase.MAJCOM : ALL_SELECT_LABEL,
    ServicingMAJCOMCode: editKnowledgeBase?.ServicingMAJCOMCode ? 
      editKnowledgeBase?.ServicingMAJCOMCode : 
      ALL_SELECT_VALUE,
    Squadron: editKnowledgeBase?.ServicingOrganization ? editKnowledgeBase.ServicingOrganization : 
    ALL_SELECT_VALUE_STRING,
    Tags: editKnowledgeBase?.Tags ? editKnowledgeBase.Tags : '',
    Title: editKnowledgeBase?.Title ? editKnowledgeBase?.Title : '',
  })
  const [knowledgeBaseValidations, setKnowledgeBaseValidations] = useState({
    Description: false,
    Title: false,
  })
  const [piiScan, setPIIScan] = useState({})

  useEffect(() => {
    if (editKnowledgeBase) {
      setInputValues((prev) => ({
      ...prev,
      AssignedComponent: editKnowledgeBase?.AssignedComponent,
      AssignedComponentCode: editKnowledgeBase?.AssignedComponentCode,
      CategoryCodeOptions: editKnowledgeBase?.CategoryCodes?.map((categoryCode, index) => ({
        label: editKnowledgeBase?.Category?.split(', ')[index],
        value: categoryCode
      })),
      CategoryCodes: editKnowledgeBase?.CategoryCodes?.length > 0 ?
        editKnowledgeBase.CategoryCodes : [],
      SectionCodeOptions: editKnowledgeBase?.SectionCodes?.map((sectionCode, index) => ({
        label: editKnowledgeBase?.Section?.split(', ')[index],
        value: sectionCode
      })),
      SectionCodes: editKnowledgeBase?.SectionCodes?.length > 0 ?
        editKnowledgeBase.SectionCodes : [],
      ServicingMAJCOM: editKnowledgeBase?.ServicingMAJCOM,
      ServicingMAJCOMCode: editKnowledgeBase?.ServicingMAJCOMCode,
    }))
  }
  }, [editKnowledgeBase])

  const handleChange = (key: string, value: number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const changeSection = (e: { label: string; value: number }) => {
    const options = []

    e.forEach((section) => {
      options.push(generateCategoryOptions(
        section.label,
        categories ?? [],
        sections ?? []
      ))
    })

    setCategoryOptions([...new Set(...options)])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('SectionCodes', sectionOptions.length === 1 ? [sectionOptions[0].value] : [...e.map((section) => section.value)])
    handleChange('SectionCodeOptions', sectionOptions.length === 1 ? [sectionOptions[0]] : e)
  }

  const changeCategory = (e: { label: string; value: number }) => {
    handleChange('CategoryCodes', categoryOptions.length === 1 ? [categoryOptions[0].value] : [...e.map((category) => category.value)])
    handleChange('CategoryCodeOptions', categoryOptions.length === 1 ? [categoryOptions[0]] : e)
  }

  const changeAssignedComponent = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
    .filter(
      (item) => item.assignedComponentCode === e.value || e.value === -1
    )
    .map((majcom) => ({
      assignedComponentCode: majcom.assignedComponentCode,
      label: majcom.label,
      squadron: majcom.squadron,
      value: majcom.value,
    }))

  const sectOptions: optionsTypes[] = sections.filter((section) => {
    let containsSquadron = false

    Object.keys(visibleSquadrons).forEach((key) => {
      if (visibleSquadrons[key].length > 0) {
        const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

        if (key === 'SectionChief' || key === 'SectionOwner') {
          if (visibleSquadrons[key]
            .some((e) => e.section === formattedSection &&
              majOptions.some((maj) => maj.squadron.includes(e.squadron)))) {
            containsSquadron = true
          }
        }
      }
    })

    return containsSquadron ||
      roleContext?.isCPOwner ||
      roleContext?.isLeadership ||
      roleContext?.isMPFOwner ||
      roleContext?.isMAJCOMOwner ||
      roleContext?.isAssignedComponentOwner
  }).map((section) => {
    const filteredSectOpt = initialSectionOptions.filter((sect) =>
      sect.value === section?.SectionCode
    )[0]

    return {
      label: section?.Section,
      majcom: filteredSectOpt.majcom,
      squadron: filteredSectOpt.squadron,
      value: section?.SectionCode,
    }
  })

  const squadOptions = []
  majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
    majcom.squadron?.map((item) => {
      squadOptions.push({
        label: item,
        value: item
      })
    })
  })

  if (majOptions.length > 1 && majOptions[0].value !== -1) {
    majOptions.unshift(ALL_SELECT_OPTION)
  }

  if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
    squadOptions.unshift(ALL_SELECT_OPTION_STRING)
  }

  setMajcomOptions(majOptions)
  setSectionOptions(sectOptions)
  setSquadronOptions(squadOptions)

  handleChange('AssignedComponent', e.label)
  handleChange('AssignedComponentCode', e.value)
  handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
  handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
  handleChange('CategoryCodes', [])
  handleChange('CategoryCodeOptions', [])
  handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
  handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? -1 : ALL_SELECT_VALUE)
  handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : '')
  }

  const changeMajcom = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let squadOptions = []

    if (e?.squadron) {
        e.squadron?.map((item) => {
          squadOptions.push({
            label: item,
            value: item
          })
        })
    } else {
      squadOptions = []
      majcomOptions.map((majcom) => {
          majcom?.squadron?.map((item) => {
            squadOptions.push({
              label: item,
              value: item
            })
          })
        })
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('ServicingMAJCOM', e.label)
    handleChange('ServicingMAJCOMCode', e.value)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : '')
  }

  const changeSquadron = (e: any) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    setSectionOptions(sectOptions)

    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('Squadron', e.value)
  }

  const changeTitle = (e: { target: { value: string } }) => {
    handleChange('Title', e.target.value)
  }

  const changeTag = (e: { target: { value: string } }) => {
    handleChange('Tags', e.target.value)
  }

  const handleInputChangeRichText = (e) => {
    handleChange('Description', e)
  }

  const changeArchived = (e) => {
    handleChange('Archived', e.value)
  }

  const knowledgeBaseSubmit = async () => {
    let isValid = true
    let isNoChangesDetected = true
    let checkTitle = true
    let checkDescription = true

    setKnowledgeBaseValidations({
      ...knowledgeBaseValidations,
      Description: false,
      Title: false,
    })

    if (!inputValues.Title || !inputValues.Title.trim()) {
      isValid = false
      checkTitle = false
    }
    if (
      !inputValues?.Description.getCurrentContent().hasText() ||
      !inputValues?.Description.getCurrentContent().getPlainText().trim()
    ) {
      isValid = false
      checkDescription = false
    }

    if (
      editKnowledgeBase?.Title === inputValues.Title.trim() &&
      removeTags(editKnowledgeBase?.Description).trim() ===
      inputValues?.Description?.getCurrentContent()?.getPlainText()?.trim() &&
      editKnowledgeBase?.Tags?.trim() === inputValues?.Tags?.trim() &&
      editKnowledgeBase?.IsArchived === inputValues?.Archived &&
      editKnowledgeBase?.SectionCodes.sort().join(',') === inputValues?.SectionCodes.sort().join(',') &&
      editKnowledgeBase?.CategoryCodes.sort().join(',') === inputValues?.CategoryCodes.sort().join(',') &&
      editKnowledgeBase?.ServicingMAJCOM === inputValues?.ServicingMAJCOM &&
      editKnowledgeBase?.AssignedComponentCode === inputValues?.AssignedComponentCode &&
      !isFilesChanged()
    ) {
      isValid = false
      isNoChangesDetected = false
    }
    if (!isNoChangesDetected) {
      setShowAlert(true)
    }
    setKnowledgeBaseValidations({
      ...knowledgeBaseValidations,
      Description: !checkDescription,
      Title: !checkTitle,
    })

    const piiIsValid = await validateAndHandlePIISubmission('submitted')
    if (isValid) {
      await saveKnowledgeBase(piiIsValid)
    }
  }
  function removeTags(html: string) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent || ''
  }
  function generateCode(code: number) {
    return code > 0 ? code : null
  }

  const generateString = (options: any) => {
    return JSON.stringify(options.map((options) => options.label))
  }

  const onClickAlert = async (button: string) => {
    if (button === 'OK') {
      setShowAlert(false)
    } else {
      setShowAlert(false)
    }
  }
  function isFilesChanged() {
    const filesSet = new Set(files.map((file) => (file.fileName ? file.fileName : file.name)))
    const existingFilesSet = new Set(existingFiles.map((file) => file.fileName))
    const hasDifferences =
      existingFiles.some((aItem) => !filesSet.has(aItem.fileName)) ||
      files.some((aItem) => !existingFilesSet.has(aItem.fileName))
    return hasDifferences
  }

  async function saveKnowledgeBase(piiIsValid) {
    setPageOverlay(true)
    const userdetails = mpfRListsHttp().me()
    const userId = (await userdetails).userId
    const currentDate = new Date()
    const addObj = {}
    addObj[KnowledgeBaseCols.Title] = inputValues.Title
    addObj[KnowledgeBaseCols.Description] = draftToHtml(
      convertToRaw(inputValues?.Description.getCurrentContent())
    )
    addObj[KnowledgeBaseCols.Tags] = inputValues.Tags
    addObj[KnowledgeBaseCols.AssignedComponentCode] = generateCode(
      inputValues.AssignedComponentCode
    )
    addObj[KnowledgeBaseCols.SectionCodes] = JSON.stringify(inputValues.SectionCodes)
    addObj[KnowledgeBaseCols.Section] = generateString(inputValues.SectionCodeOptions)
    addObj[KnowledgeBaseCols.ServicingMAJCOMCode] = generateCode(inputValues.ServicingMAJCOMCode)
    addObj[KnowledgeBaseCols.CategoryCodes] = JSON.stringify(inputValues.CategoryCodes)
    addObj[KnowledgeBaseCols.Category] = generateString(inputValues.CategoryCodeOptions)
    addObj[KnowledgeBaseCols.Squadron] = inputValues.Squadron
    addObj[KnowledgeBaseCols.IsArchived] = inputValues?.Archived ? inputValues?.Archived : false
    addObj[KnowledgeBaseCols.ItemModified] = currentDate
    addObj[KnowledgeBaseCols.ItemCreated] = currentDate
    addObj[KnowledgeBaseCols.ItemModifiedBy] = userId
    addObj[KnowledgeBaseCols.ItemCreatedBy] = userId
    addObj[KnowledgeBaseCols.EKey] = !editKnowledgeBase ? '' : editKnowledgeBase?.eKey
    addObj[KnowledgeBaseCols.ETag] = !editKnowledgeBase ? '' : editKnowledgeBase?.eTag
    if (piiIsValid) {
      try {
        const actual = await saveOrUpdateKnowledgeBase(addObj)
        addToPIIAuditTrail(
          'Settings-KnowledgeBase',
          addObj[KnowledgeBaseCols.EKey],
          piiScan,
          userId
        )
        const itemkey = actual.eKey
        const newKnowledgeBase: KnowledgeBaseInterface = {
          ...actual,
          AssignedComponent: inputValues.AssignedComponent,
          Category: inputValues.CategoryCodeOptions.map((options) => options.label),
          CategoryCodes: inputValues.CategoryCodes,
          Id: actual.eKey,
          Section: inputValues.SectionCodeOptions.map((options) => options.label),
          SectionCodes: inputValues.SectionCodes,
          ServicingMAJCOM: inputValues.ServicingMAJCOM,
          Squadron: inputValues.Squadron,
        }
        const prevKnowledges = oldKnowledgeBases.filter(
          (item) => item.eKey !== newKnowledgeBase.eKey
        )

        if (editKnowledgeBase && isFilesChanged()) {
          const deletedFiles = existingFiles.filter(
            (aItem) => !files.some((bItem: any) => bItem.fileName === aItem.fileName)
          )
          try {
            const listname = await mpfRListsHttp().getList(KnowledgeBaselist)
            for (const element of deletedFiles) {
              const deletedEtag = element.eTag
              await listname
                .blobs()
                .delete(editKnowledgeBase.eKey, element.fileName, element.folderName, deletedEtag)
            }
          } catch (error) {
            console.error('Error occurred while deleting attachment:', error)
          }
        }
        if (files?.length > 0) {
          const promises = []
          promises.push(listAttachments(KnowledgeBaselist, itemkey, files))
          Promise.all(promises)
            .then(function () {
              cancel()
              prevKnowledges.unshift(newKnowledgeBase)
              setOldKnowledgeBases(prevKnowledges)
              setKnowledgeBases(prevKnowledges)
              setRefresh(!refresh)
              setPageOverlay(false)
            })
            .catch(function (error) {
              console.error(error)
            })
        } else {
          cancel()
          prevKnowledges.unshift(newKnowledgeBase)
          setOldKnowledgeBases(prevKnowledges)
          setKnowledgeBases(prevKnowledges)
          setRefresh(!refresh)
          setPageOverlay(false)
        }
      } catch (error) {
        console.error('error', error)
      }
    }
    setPageOverlay(false)
  }

  /**validateAndHandlePIISubmission
   * Validates the PII (Personally Identifiable Information) for submission and handles the submission process.
   *
   * @param {string} action - The action being performed (e.g., 'submitted').
   * @param {string} position - The position to displayValidation PII compliance validation messages ('top' or 'bottom').
   * @returns {boolean} - Indicates whether the submission can proceed.
   */
  const validateAndHandlePIISubmission = async (action = 'submitted') => {
    let canSubmit = true
    const piiScanData = {
      Description: convertRTE(inputValues?.Description),
      FileArray: Object.values(files),
      Title: inputValues.Title,
    }
    try {
      const uploadData = await getPIIScanInfo(piiScanData, piiScan)
      if (action === 'submitted') {
        setPIIScan({ ...uploadData.piiScanResult })
      }
      if (uploadData.canSubmit) {
        canSubmit = true
      } else {
        handlePIIValidationFailure(null, setDisplayValidation)
        canSubmit = false
      }
    } catch (error) {
      console.error('PII validation failed:', error)
      canSubmit = false
    }
    return canSubmit
  }

  useEffect(() => {
    const titleElemnt = document.getElementById('Title')
    if (titleRef?.current && titleElemnt) {
      if (clickedIndex === 0) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'end' })
        titleElemnt.focus()
      } else if (clickedIndex === 1) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'nearest' })
        titleElemnt.focus()
      } else {
        titleRef?.current?.scrollIntoView(false)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showEdit, descriptionRef])

  useEffect(() => {
    setDisplayValidation((prev) => ({
      ...prev,
      showPII: false,
    }))
    if (Object.keys(piiScan).length > 0) {
      Object.keys(piiScan).forEach((key) => {
        if (key === 'FileArray') {
          for (const file of piiScan[key].value) {
            if (file?.resultsArray?.length > 0 && !file?.userAnswer) {
              setDisplayValidation((prev) => ({
                ...prev,
                showPII: true,
              }))
            }
          }
        } else {
          if (piiScan[key]?.resultsArray?.length > 0 && !piiScan[key]?.userAnswer) {
            setDisplayValidation((prev) => ({
              ...prev,
              showPII: true,
            }))
          }
        }
      })
    }
  }, [piiScan])

  useEffect(() => {
    loadPII()
  }, [])

  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label='Add Knowledge Base'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add Knowledge Base
          </h4>
        </div>
      )}
      {displayValidation.showPII && <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />}
      <div className='px-2 py-1'>
        <div className='row'>
          <div className='col-sm-12 col-lg-12 mb-2' ref={titleRef}>
            <InputText
              changeHandler={changeTitle}
              error={knowledgeBaseValidations.Title}
              formClassName='d-flex flex-column'
              info='Title '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Title',
                name: ' Title',
                placeholder: 'Enter Title',
                value: inputValues.Title,
              }}
              isInfo
              isMandatory
              label=' Title '
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2' ref={descriptionRef}>
            <RichTextEditor
              defaultValue={undefined}
              editorValue={!showAddPopup ? editKnowledgeBase.Description : null}
              error={knowledgeBaseValidations.Description}
              formClassName='d-flex flex-column'
              hint={knowledgeBaseValidations.Description}
              info='Description '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Description ',
                name: ' Description',
                placeholder: 'Enter Description',
              }}
              isInfo
              isMandatory
              label='Description '
              sendValue={handleInputChangeRichText}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2'>
            <FileUpload
              filesProps={{ files, setFiles }}
              formClassName='d-flex flex-column'
              hint='Hint: Acceptable file types: docx, doc, pdf, txt, jpg, jpeg, png, xlsx, xls, pptx, ppt. The following special characters are not allowed in the document names: , ! @ # $ % ^ & * ( ) + = [ ] { } ‘ : “ \ | < > / ? ~. 
              Maximum file size is 25 MB. Maximum number of files is 10'
              hintClassName='color-primary'
              info='Attach file (s) '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Attach files ',
                name: ' Description',
              }}
              isInfo
              label='Attach file (s) '
              note='Screenshots need to be saved locally before uploading into system'
              noteClassName='color-primary'
              replaceFileProps={{ replaceFile, setReplaceFile }}
              setFileError={setFileError}
            />
          </div>
          <div className='col-sm-12 col-lg-8 mb-2'>
            <InputText
              changeHandler={changeTag}
              formClassName='d-flex flex-column'
              info='Tags '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Tags ',
                name: ' Tags',
                placeholder: 'Enter Tags',
                value: inputValues.Tags,
              }}
              isInfo
              label=' Tags '
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AssignedComponent'
              info='Assigned Component '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='AssignedComponent'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Assigned Component'
              onChange={changeAssignedComponent}
              options={assignedComponentOptions}
              value={inputValues?.AssignedComponentCode}
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingMAJCOM'
              info='Servicing MAJCOM'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing MAJCOM'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing MAJCOM'
              onChange={changeMajcom}
              options={majcomOptions}
              value={inputValues?.ServicingMAJCOMCode}
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner || 
                roleContext.isMAJCOMOwner}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingOrganization'
              info='Servicing Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing Organization'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing Organization'
              onChange={changeSquadron}
              options={squadronOptions}
              value={inputValues?.Squadron}
            />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Section'
              info='Section '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Section'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Section'
              onChange={changeSection}
              options={sectionOptions}
              value={inputValues?.SectionCodeOptions}
            />
          </div>
          {inputValues.SectionCodes.length === 1 &&<div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='DashboardCategory'
              info='Category '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Category'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Category'
              onChange={changeCategory}
              options={categoryOptions}
              value={inputValues?.CategoryCodeOptions}
            />
          </div>}
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Is Archived'
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={changeArchived}
                options={IsArchived}
                value={inputValues?.Archived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={() => {
                    knowledgeBaseSubmit()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={() => {
                    knowledgeBaseSubmit()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
